// extracted by mini-css-extract-plugin
module.exports = {"margin-bottom30px":"style_margin-bottom30px__33qMu","margin-top10px":"style_margin-top10px__1PQUm"};